export enum AUTHORIZATION_STATE {
    PENDING = 1,
    SIGNED = 2,
    REVOKED = 3,
}

export enum AUTHORIZATION_TYPE {
    CLOCKINS_PERSONAL_PHONE = 1,
}

export interface Authorization {
    uid: string,
    locUid: string,
    type: AUTHORIZATION_TYPE,
    state: AUTHORIZATION_STATE,
    documentUrl: string,
    createdOn?: Date,
    signedOn?: Date,
    revokedOn?: Date,
}
